import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class FleetApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurlFleet(path, queryMap);
  }

  findFleetCards(
    access: any,
    current: any,
    Authorization: any,
    node_id: number,
    page: number,
    page_size: number
  ) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const q = {
      node_id,
      page,
      page_size,
    };
    const url = this.buildurl('/official/car/list', q);
    return this.http.fget(url, options);
  }

  findNodes(access: any, current: any, Authorization: any) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const url = this.buildurl('/official/car/node');
    return this.http.fget(url, options);
  }

  loginFleet(
    car: any,
    is_plus: number,
    currentLogin: string,
    sign: string,
    models: any,
    access: any,
    current: any,
    Authorization: any
  ) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const body = { car, is_plus, current: currentLogin, sign, models };
    const url = this.buildurl('/official/car/login');
    return this.http.post(url, body, options);
  }

  getOfficialUserRemain(access: any, current: any, Authorization: any) {
    const head = { access, current, Authorization };
    const options = { headers: head };
    const url = this.buildurl('/official/user/remain');
    return this.http.fget(url, options);
  }
}
